"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileBody = void 0;
var _react = _interopRequireDefault(require("react"));
var _Body = require("../../Body");
var _Image360Item = require("../../Body/Body/ItemList/Image360Item");
var _ImageItem = require("../../Body/Body/ItemList/ImageItem");
var _VideoItem = require("../../Body/Body/ItemList/VideoItem");
var MobileBody = function MobileBody(props) {
  return /*#__PURE__*/_react["default"].createElement(_Body.Body, props);
};
exports.MobileBody = MobileBody;
MobileBody.defaultProps = {
  Image360ItemComponent: _Image360Item.Image360Item,
  ImageItemComponent: _ImageItem.ImageItem,
  isMobile: true,
  VideoItemComponent: _VideoItem.VideoItem
};